import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface KpiList {
  kpiDefinitionId: number
  kpiName: string
  kpiDescription: string
}
export interface KpiListState {
  isLoading: boolean
  loadingError: string | null
  kpiList: KpiList[] | null
  kpiCount: number
  httpStatus: number | null
}

const initialState: KpiListState = {
  isLoading: true,
  loadingError: null,
  kpiList: null,
  kpiCount: 0,
  httpStatus: null
}

const kpiListSlice = createSlice({
  name: 'kpiList',
  initialState,
  reducers: {
    kpiListLoadingAction: (state) => {
      return {
        isLoading: true,
        loadingError: null,
        kpiList: null,
        kpiCount: 0,
        httpStatus: 0
      }
    },
    kpiListUpdateAction: (state, action: PayloadAction<{ data: KpiList[], count: number, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: null,
        kpiList: action.payload.data,
        kpiCount: action.payload.count,
        httpStatus: action.payload.httpStatus
      }
    },
    kpiListErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        isLoading: false,
        loadingError: action.payload.errorMessage,
        kpiList: null,
        kpiCount: 0,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  kpiListLoadingAction,
  kpiListUpdateAction,
  kpiListErrorAction
} = kpiListSlice.actions

export default kpiListSlice.reducer
